import { VFC } from 'react'
import { LoginUser, Responsibilities } from 'src/models/User'
import { AVAILABLITIES_OPTIONS } from 'src/utils/data'
import { ProfileEditorWrapper } from '../ProfileLayout'
import { BooleanSelect, FormTextarea, ProfileForm } from '../formComponents'
import { MasterDataMultiSelectWithModal } from '../formComponents/FormMultiSelectWithModal'

type ResponsibilitiesFormProps = {
  user: LoginUser
  submit: (responsibilities: Responsibilities) => Promise<any>
}

export const ResponsibilitiesForm: VFC<ResponsibilitiesFormProps> = ({
  user,
  submit,
}) => (
  <ProfileEditorWrapper user={user}>
    <ProfileForm
      title="決裁者情報"
      user={user}
      propertyKey="responsibilities"
      submit={submit}
      isProfile
    >
      <MasterDataMultiSelectWithModal
        type="resposibleDomains"
        id="domains"
        label="決裁領域"
        description="あなたの決裁領域情報を入力してください！（複数可）"
        onlineMtgAvailable={user.responsibilities.onlineMtgAvailable || null}
        message={user.responsibilities.message || null}
        optional
      />
      <MasterDataMultiSelectWithModal
        type="features"
        id="features"
        label="特徴"
        description="あなた（決裁者）の情報を入力してください！（複数可）"
        onlineMtgAvailable={user.responsibilities.onlineMtgAvailable || null}
        message={user.responsibilities.message || null}
        optional
      />
      <BooleanSelect
        id="onlineMtgAvailable"
        label="オンラインアポイント"
        options={AVAILABLITIES_OPTIONS}
      />
      <FormTextarea
        id="message"
        label="自己紹介"
        note="(800文字まで)"
        optional
      />
    </ProfileForm>
  </ProfileEditorWrapper>
)
